export const SEARCH_QUERY_URL = (query: string) => `/?q=${query}&orderBy=1`;
export const PACKAGE_CANONICAL_URL = (packageId: number | string) =>
  `/packages/package/${packageId}`;
